export default {
    SUCCESS: 0, // 成功
    PARAMS_FAILD: 422, // 参数错误
    TOKEN_OUTDATED: 1000, // token过期
    YZM_ERROR: 300009, // 验证码错误
    NO_STORE: 300072, // 门店不存在
    TOKEN_NO_EXIST: 500102, // token不存在
    NO_AUTH: 500503, // 权限不足 
    FETCH_FAILD: 500506, // 获取失败
    ADD_FAILD: 500507, // 添加失败
}